/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetAllAssets = (data: any) =>
  useQuery<any>({
    queryKey: ["GetAllAssets", data?.pageNumber, data?.searchCriteria],
    queryFn: ({ signal }) => client(`resources/assets`, { data, signal }),
  });
